module.exports = __webpack_public_path__ + "static/img/thumb.a6183da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/review/thumb.png
// module id = 6PCS
// module chunks = 0